import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { NgForm } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { AuthenticationService } from '../../user/_services/authentication.service';
import { FORM_MSGS } from 'src/app/_common/product-config';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {

  @ViewChild("newForm", {static:true}) resetForm: NgForm;

  private loading: boolean = false;
  private submitted:boolean = false;
  private errorMessage:string = '';
  private passwordContainsName: boolean = false;
  private formMsgs = FORM_MSGS;

  @Input() public uid;

  constructor(private modalService : NgbActiveModal, private router: Router, private authenticationService: AuthenticationService) { }

  ngOnInit() {
  }

  onResetPassword(){
    if(this.resetForm.valid){
      this.loading = true; 
      this.authenticationService.reset(this.uid, this.resetForm['newPassword'], this.resetForm['confirmPassword']).subscribe(data=>{
        this.loading = false; 
        this.modalService.close({error: false});
        this.router.navigateByUrl("/login", {replaceUrl: true});
      },
      error => {
        if(error.error.errorContent.message == this.formMsgs.PasswordContainsName){
          this.passwordContainsName = true;
        }
        else{
          this.errorMessage = this.formMsgs.SomethingWentWrong;
        }
        this.loading = false;
      });
    }
  }

}
